// import $ from 'jquery';
// import { createAlert } from 'dom/window';
import _ from 'lodash'
import { axiosInstance as axios, handleAxiosErrors } from '_utils'
import config from 'store/_config'
// import { getProductByID, getProductsFullInfo } from '../selectors/defaultSelectors';

export const toggleCocktailsLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_COCKTAILS_FULL_LOADING',
      value: value,
    })
  }
}
export const toggleCocktailLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_COCKTAIL_LOADING',
      value: value,
    })
  }
}

export const requestCocktails = (params) => {
  return (dispatch, getState) => {
    let { url, query } = config.cocktails.listing
    return axios
      .post(url, {
        withCredentials: true,
        query: query,
      })
      .then((response) => {
        dispatch(toggleCocktailsLoading(false))
        const cocktails = convertCocktailsListToAReadableFormat(response.data.data.readCocktails.edges)
        dispatch(updateCocktails(cocktails))
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const convertCocktailToAReadableFormat = (item) => {
  let newList = []

  const {
    IngredientsTitle,
    ProductsID,
    MethodContent,
    Title,
    CocktailDetailImage,
    CocktailListingImage,
    CocktailThumbnailImage,
    ID,
  } = item

  newList.push({
    id: String(ID),
    title: Title,
    // video: VideoUrl, // TODO: not necessary ???
    thumbnailImg: CocktailThumbnailImage,
    listingImg: CocktailListingImage,
    headerImg: CocktailDetailImage,
    method: MethodContent,
    ingredients: IngredientsTitle.split(','),
    products: ProductsID.split(',').map(Number),
    isAddToTemplate: false,
  })

  return newList
}
export const convertCocktailsListToAReadableFormat = (list) => {
  let newList = []

  list.map((item) => {
    const { URLSegment, Title, CocktailListingImage, ID, Excerpt } = item.node
    newList.push({
      id: String(ID),
      url: URLSegment,
      img: CocktailListingImage,
      title: Title,
      excerpt: Excerpt,
    })
  })

  return newList
}

export const updateCocktails = (list) => {
  return {
    type: 'UPDATE_COCKTAILS_LIST',
    list: _.keyBy(list, 'id'),
  }
}
